import React from "react";
import { Link } from "react-router-dom";
import { Package, ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export default function BundleCard({ bundle, idx = 0 }) {
  const { lang, t } = useLanguage();
  const title = lang === "en" ? bundle.title_en : bundle.title_no;
  const short = lang === "en" ? bundle.short_en : bundle.short_no;

  return (
    <Link
      to={`/pakke/${bundle.slug}`}
      data-testid={`bundle-card-${bundle.slug}`}
      className="group block bg-white border border-[#E5E2DC] rounded-2xl overflow-hidden transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] relative"
      style={{ animationDelay: `${idx * 60}ms` }}
    >
      {/* Discount Badge */}
      <div className="absolute top-4 left-4 z-10 bg-[#D97B66] text-white rounded-full px-3 py-1 text-xs font-medium tracking-wide">
        −{bundle.savings_percent}%
      </div>

      <div className="aspect-[4/5] overflow-hidden bg-[#F9F8F6] relative">
        <img
          src={bundle.image_url}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1 text-xs font-medium text-[#2C302E] inline-flex items-center gap-1.5">
          <Package className="w-3 h-3" strokeWidth={2} />
          {bundle.products?.length} {t("bundle_products")}
        </div>
      </div>
      <div className="p-6">
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#D97B66] font-medium mb-2">
          {t("bundles_eyebrow")}
        </p>
        <div className="flex items-start justify-between gap-3 mb-2">
          <h3 className="font-heading text-lg md:text-xl text-[#2C302E] leading-snug font-medium">
            {title}
          </h3>
          <ArrowUpRight
            className="w-5 h-5 text-[#6B726C] flex-shrink-0 mt-0.5 group-hover:text-[#D97B66] transition-colors"
            strokeWidth={1.5}
          />
        </div>
        <p className="text-sm text-[#6B726C] leading-relaxed line-clamp-2 mb-5">
          {short}
        </p>
        <div className="flex items-end justify-between pt-4 border-t border-[#E5E2DC]">
          <div>
            <p className="text-[10px] uppercase tracking-widest text-[#6B726C]">
              {t("bundle_value")} {bundle.original_price_nok} NOK
            </p>
            <p className="font-heading text-xl text-[#2C302E] font-medium">
              {bundle.price_nok} <span className="text-sm text-[#6B726C]">NOK</span>
            </p>
          </div>
          <span className="text-xs text-[#8BA896] group-hover:text-[#D97B66] transition-colors font-medium">
            {t("bundle_save")} {bundle.savings_nok} NOK →
          </span>
        </div>
      </div>
    </Link>
  );
}
